<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    :rules="rules"
    clearable
    :label="label"
    return-object
    hide-details
    hide-selected
    :disabled="readonly"
    autocomplete="nope"
    outlined
    dense
    no-filter
    no-data-text="Данные не выбраны"
    :class="{'red lighten-4':selected && selected.isRemoved}"
    :menu-props="menuPropsClose"
    :error="error"
    prepend-inner-icon="mdi-folder-outline"
    @change="handleItemChange"
    @click="closeMenuPropsOnClick(false)"
  >
    <template v-slot:append>
      <AddReferenceBtn @click="createNew" />
    </template>
  </v-autocomplete>
</template>
<script>
import AddReferenceBtn from "../AddReferenceBtn.vue";
import CloseDropdownList from "../../mixins/close-dropdown-list.js";
import { NestedEditorsEventBus } from "../nested-editors/nested-editors-event-bus.js";
import * as countriesApi from "../../backend/countriesApi.js";

export default {
  components: { AddReferenceBtn },
  mixins: [CloseDropdownList],
  props: [
    "value",
    "label",
    "rules",
    "resource",
    "withoutUkraine",
    "disabled",
    "componentName",
    "outline",
    "error",
    "scrollValue",
  ],
  data() {
    return {
      selected: null,
      search: null,
      items: [],
      loading: false,
    };
  },
  computed: {
    readonly() {
      return this.disabled;
    },
    changedResource() {
      return this.withoutUkraine
        ? `${this.resource}/without-ukraine`
        : `${this.resource}`;
    },
  },
  watch: {
    value: {
      handler() {
        if (!this.value) {
          this.selected = null;
          this.search = null;
          this.items = [];
          return;
        }
        if (this.selected && this.value.id === this.selected.value) {
          return;
        }
        const selectedItem = this.items.find((i) => i.value === this.value.id);
        if (selectedItem) {
          this.selected = selectedItem;
        } else {
          this.setSelectedElement(this.value);
        }
      },
      deep: true,
    },
    search() {
      if (!this.search) {
        this.selected = null;
        this.fetchAll();
        return;
      }

      if (this.loading) {
        return;
      }

      if (this.selected && this.selected.text === this.search) {
        return;
      }

      this.loading = true;
      setTimeout(() => {
        if (!this.search) {
          this.selected = null;
          this.items = [];
          this.loading = false;
          return;
        }

        this.searchCountry(this.search);
        this.loading = false;
      }, 500);
    },
    scrollValue() {
      if (!this.scrollValue) {
        return;
      }
      closeActivList(this.$children[0]);

      function closeActivList(value) {
        if (value.isActive) {
          value.isActive = false;
        }
        if (value.$children) {
          value.$children.forEach((v) => closeActivList(v));
        }
      }
    },
  },
  created() {
    if (this.value) {
      this.setSelectedElement(this.value);
    }
    NestedEditorsEventBus.$on("create-" + this._uid, (createdId) => {
      this.getCountryReference(createdId);
      this.handleItemChange();
    });
  },
  mounted() {
    this.$watch(
      () => {
        return this.$children[0].$data.isMenuActive;
      },
      (newVal) => {
        if (newVal) {
          this.fetchAll();
        } else {
          this.clear();
        }
      },
    );
  },
  methods: {
    handleItemChange() {
      this.$emit(
        "input",
        this.selected
          ? { id: this.selected.value, title: this.selected.text }
          : null,
      );
    },
    async fetchAll() {
      this.items = await countriesApi.fetchCountries(this.changedResource);
      this.loading = false;
    },
    clear() {
      this.items = [];
      if (this.selected) {
        this.items.push(this.selected);
      }
    },
    createNew() {
      this.closeMenuPropsOnClick(true);
      this.$emit("click");
      NestedEditorsEventBus.$emit("open", {
        title: this.label,
        uid: this._uid,
        component: this.componentName,
      });
    },
    setSelectedElement(value) {
      const newItem = {
        text: value.title,
        value: value.id,
        isRemoved: value.isRemoved,
      };
      this.items.push(newItem);
      this.selected = newItem;
    },
    async getCountryReference(createdId) {
      const response = await countriesApi.getCountryReference(
        this.resource,
        createdId,
      );
      this.setSelectedElement(response);
    },
    async searchCountry(queryParams) {
      this.items = await countriesApi.searchReferencies(
        this.changedResource,
        queryParams,
      );
    },
  },
};
</script>
